// the body class has a hard coded width that needs to be modified
export const modifyApollo = (emailContainer: HTMLElement, selector: string) => {
  if (emailContainer?.matches(selector)) {
    const trimmedSelector = selector.replace(".", "");
    emailContainer.classList.remove(trimmedSelector);
  }
};
